/* Carousel horizontal — types de couteaux */
(function () {
  'use strict';

  var track = document.getElementById('mrg-types-track');
  if (!track) return;

  document.querySelectorAll('[data-mrg-scroll]').forEach(function (button) {
    button.addEventListener('click', function () {
      var direction = button.getAttribute('data-mrg-scroll') === 'prev' ? -1 : 1;
      var card = track.querySelector('.mrg-type-card');
      var gap = parseFloat(getComputedStyle(track).gap) || 20;
      var amount = (card ? card.offsetWidth + gap : track.clientWidth * 0.8) * direction;
      track.scrollBy({ left: amount, behavior: 'smooth' });
    });
  });
})();
